import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import axiosInstance from '../../api/axiosInstance';
// Async thunk to fetch social links from the API
export const fetchSocialLinks = createAsyncThunk(
  'socialLinks/fetchSocialLinks',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.post(
        '/api/Common/GetWebsiteSettings',
        { websiteType: 1 }, // Request body
        { headers: { 'Content-Type': 'application/json-patch+json' } }
      );

      // Parse the response and return the filtered social links
      const data = JSON.parse(response.data.message);
      return data.filter(
        (item) => item.WebisteLinkType >= 1 && item.WebisteLinkType <= 6
      );
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const socialLinksSlice = createSlice({
  name: 'socialLinks',
  initialState: {
    socialLinks: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSocialLinks.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchSocialLinks.fulfilled, (state, action) => {
        state.loading = false;
        state.socialLinks = action.payload; // Set the filtered social links
      })
      .addCase(fetchSocialLinks.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload; // Store the error message
      });
  },
});

export const selectSocialLinks = (state) => state.socialLinks.socialLinks;
export const selectSocialLinksLoading = (state) => state.socialLinks.loading;
export const selectSocialLinksError = (state) => state.socialLinks.error;

export default socialLinksSlice.reducer;
